module.exports = __webpack_public_path__ + "i18n/nl.02647a4cdcb950ef498f9ca580ed9528.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/nl.json
// module id = 1312
// module chunks = 59